<div class="description-container">
    <div>
        <i class="icon-alert-circle"></i>
    </div>

    <div>
        <h6 class="title">
            Charger le fichier géopackage et les paramètres pour réaliser votre simulation
        </h6>
        <!-- <p>Charger le fichier géopackage et les paramètres pour réaliser votre simulation</p> -->
    </div>
</div>

<div class="load-files-container container-fluid">
    <div class="row">
        <div class="col-6">
            <div class="card">
                <h5 class="title">1. Charger le fichier GeoPackage</h5>

                <div class="input-file-container">
                    <ed-input-file
                        innerId="input-file-gpkg"
                        [allowedFormat]="['gpkg']"
                        [fileTypeLabel]="'GeoPackage'"
                        [maxFileSizeInMo]="50"
                        [fileSizeUnit]="'Mo'"
                        [isUploading]="isUploading"
                        [resetTrigger]="resetGpkgCounter"
                        (onSubmit)="onGpkgFileUpload($event)"></ed-input-file>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card">
                <h5 class="title">2. Charger le fichier de paramètres de la simulation</h5>

                <div class="input-file-container">
                    <ed-input-file
                        innerId="input-file-xlsx"
                        [allowedFormat]="['xlsx']"
                        [fileTypeLabel]="'Excel'"
                        [maxFileSizeInMo]="1"
                        [fileSizeUnit]="'Ko'"
                        [isUploading]="isUploading"
                        [resetTrigger]="resetXlsxCounter"
                        [isAnyErrorDefined]="xlsxErrors.length > 0"
                        (onSubmit)="onXlsxFileUpload($event)">
                        <ng-template>
                            <div class="errors-list container-fluid">
                                @for (paramError of xlsxErrors; track paramError.label) {
                                    <div class="row">
                                        <div class="col-5 name">{{ paramError.label }}</div>
                                        <div class="col-7 info">
                                            @for (msg of paramError.errors; track msg) {
                                                <div>{{ msg }}</div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </ng-template>
                    </ed-input-file>
                </div>

                <div class="template">
                    <div class="description">
                        <div class="title">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="6" y="1.5" width="18" height="21" rx="2" fill="#2FB776" />
                                <path
                                    d="M6 17.25H24V20.5C24 21.6046 23.1046 22.5 22 22.5H8C6.89543 22.5 6 21.6046 6 20.5V17.25Z"
                                    fill="url(#paint0_linear_27313_38464)" />
                                <rect x="15" y="12" width="9" height="5.25" fill="#229C5B" />
                                <rect x="15" y="6.75" width="9" height="5.25" fill="#27AE68" />
                                <path
                                    d="M6 3.5C6 2.39543 6.89543 1.5 8 1.5H15V6.75H6V3.5Z"
                                    fill="#1D854F" />
                                <rect x="6" y="6.75" width="9" height="5.25" fill="#197B43" />
                                <rect x="6" y="12" width="9" height="5.25" fill="#1B5B38" />
                                <path
                                    d="M6 9.75C6 8.09315 7.34315 6.75 9 6.75H12C13.6569 6.75 15 8.09315 15 9.75V17.25C15 18.9069 13.6569 20.25 12 20.25H6V9.75Z"
                                    fill="black"
                                    fill-opacity="0.3" />
                                <rect
                                    y="5.25"
                                    width="13.5"
                                    height="13.5"
                                    rx="2"
                                    fill="url(#paint1_linear_27313_38464)" />
                                <path
                                    d="M9.75 15.75L7.6366 11.925L9.65722 8.25H8.00773L6.76031 10.5964L5.53351 8.25H3.83247L5.8634 11.925L3.75 15.75H5.39948L6.72938 13.2643L8.04897 15.75H9.75Z"
                                    fill="white" />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_27313_38464"
                                        x1="6"
                                        y1="19.875"
                                        x2="24"
                                        y2="19.875"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#163C27" />
                                        <stop offset="1" stop-color="#2A6043" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear_27313_38464"
                                        x1="0"
                                        y1="12"
                                        x2="13.5"
                                        y2="12"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#185A30" />
                                        <stop offset="1" stop-color="#176F3D" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <h6>Modèle</h6>
                        </div>
                        <p>
                            Vous pouvez télécharger le fichier modèle de paramétrage de votre
                            simulation.
                        </p>
                    </div>

                    <ed-button (click)="downloadTemplate()" [colorSchema]="buttonColors.Secondary"
                        >Télécharger</ed-button
                    >
                </div>
            </div>
        </div>
    </div>
</div>

@if (canRunSimulation) {
    <div class="run-simulation-container">
        <ed-button (click)="openModalRunSimulation()">Lancer la simulation</ed-button>
    </div>
}
